module.exports = __webpack_public_path__ + "img/licence-details-icon.1427bdae.svg";